export default "__VITE_ASSET__CZzuU8fv__"